<template>
  <div
    class="c-banner"
    :class="{ '-is-editable': isEditable }"
    @mouseenter="isTooltipActive = true"
    @mouseleave="isTooltipActive = false"
  >
    <figure
      class="c-banner_wrap"
      v-if="editingCoverImage || profile.coverImageUrl"
    >
      <img
        class="c-banner_image js_c-banner-image"
        :src="editingCoverImage || profile.coverImageUrl"
        fetchpriority="high"
      >
    </figure>
    <div
      class="c-banner_control"
      v-if="isEditable && !isEditing && !isLoading"
    >
      <BalloonTooltip
        width="310px"
        @active-change="isTooltipActive = $event"
        :is-active="isTooltipActive"
        ref="tooltip"
        v-if="$ua.isFromPc() && !profile.coverImageUrl"
      >
        <a
          class="c-banner_controlTrigger"
          href="javascript:;"
          @mouseenter="isTooltipActive = false"
          @mouseleave="isTooltipActive = true"
          @click="isEditing = true"
          slot="trigger"
        >
          <CoconalaIcon
            name="camera-plus"
            color="primary"
          />カバー画像を変更
        </a>
        <span slot="title">カバー画像を依頼してみましょう！</span>
        <p slot="body">
          ココナラでは沢山のデザイナーが出品しています。<br>
          バナー画像を依頼して、魅力を伝えましょう。<br>
          <span class="c-banner_recommendSize">推奨のサイズ: 1280 x 420 px</span>
        </p>
        <div slot="footer">
          バナー・ヘッダーカテゴリは<a
            :href="$coconala.url('/categories/353')"
            target="_blank"
            rel="noopener"
          >こちら</a>
        </div>
      </BalloonTooltip>
      <a
        class="c-banner_controlTrigger"
        @click="isEditing = true"
        v-else
      >
        <CoconalaIcon
          name="camera-plus"
          color="primary"
        />カバー画像を変更
      </a>
    </div>
    <BannerEditor
      :cover-image="profile.coverImageUrl"
      :editing-cover-image.sync="editingCoverImage"
      @cancel="isEditing = false"
      @updated="onUpdated"
      @deleted="onDeleted"
      v-if="isEditable"
      v-show="isEditing"
    />
  </div>
</template>
<script>
import BalloonTooltip from '~/components/molecules/BalloonTooltip'
import BannerEditor from './BannerEditor'

const LOADING_TIME = 100

export default {
  components: {
    BalloonTooltip,
    BannerEditor
  },
  props: {
    isEditable: {
      type: Boolean,
      default: false
    },
    profile: {
      type: Object
    }
  },
  data() {
    return {
      isTooltipActive: false,
      isEditing: false,
      isLoading: false,
      editingCoverImage: null,
      intervalTimes: 0
    }
  },
  methods: {
    onUpdated() {
      this.$nextTick(() => {
        this.isEditing = false
        this.isLoading = false
      })
    },
    onDeleted() {
      this.$nextTick(() => {
        this.isEditing = false
        this.isLoading = false
      })
    }
  },
  /**
   * @returns {import('vue-meta').MetaInfo}
   */
  head() {
    // カバー画像がある場合はpreloadしておく
    if (this.profile?.coverImageUrl) {
      return {
        link: [
          {
            rel: 'preload',
            href: this.profile.coverImageUrl,
            as: 'image'
          }
        ]
      }
    }
    return {}
  }
}
</script>
<style lang="scss" scoped>
.c-banner {
  position: relative;
  padding-bottom: (420% / 1280 * 100);
  &.-is-editable {
    background-color: $color-gray-50;
  }
  &_wrap {
  }
  &_image {
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
    transform: translate(0, 0);
    display: block;

    &-loading {
      display: none;
      transform: translate(-10%, -10%);
    }
  }
  &_control {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;
  }
  &_controlTrigger {
    font-size: 20px;
    font-weight: bold;
    color: $color-link-base;
    background-color: rgba($color-gray-100, 0.8);
    display: inline-block;
    border-radius: 40px;
    padding: 5px 2em;
    white-space: nowrap;
    cursor: pointer;
    user-select: none;
    &:hover {
      background-color: rgba($color-gray-100, 1);
    }
    i {
      font-size: 28px;
      margin-right: 0.25em;
    }
  }
  &_recommendSize {
    color: $color-font-light;
  }

  @media (max-width: $breakpoint-l) {
    &_controlTrigger {
      font-size: 16px;
      i {
        font-size: 20px;
      }
    }
  }

  @media (max-width: $breakpoint-s) {
    &_controlTrigger {
      font-size: 13px;
      i {
        font-size: 16px;
      }
    }
  }
}
</style>
